// import React, { useState, useEffect } from "react";
// import Sidebar from "../../CommonComponent/sidebar/Sidebar";
// import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
// import { Footer } from "../../Footer";
// import { GetNotificationMes, GetNotificationMesDataPlayer } from "../../redux/auth-reducer/auth-service";
// import dayjs from "dayjs";
// import { Button, Col, Row } from "react-bootstrap";
// import * as icons from 'react-bootstrap-icons';

// export const Notification = () => {
//   const [data, setData] = useState(false);
//   const [itemData, setItemData] = useState([]);
//   const [itemLastData, setItemLastData] = useState([]);
//   const [notificationMes, setNotificationMes] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [notificationsPerPage] = useState(10);
//   const [activePage, setActivePage] = useState(1);
//   const getDetails = localStorage?.getItem("role")
//   const [perPage, setPerPage] = useState(10);
//   const [totalRows, setTotalRows] = useState(1);
//   const pageOptions = [10, 20, 30, 50];
//   useEffect(() => {
//     notificationMes?.map((item) => {
//       var user = item?.roleName.split(" ");
//       var dataList = user?.[0] || "";
//       var dataList2 = user?.[1] || "";
//       var listItem = dataList.charAt(0);
//       var listItem2 = dataList2.charAt(0);
//       setItemData(listItem)
//       setItemLastData(listItem2);

//     });
//   }, [notificationMes]);

//   // useEffect(() => {
//   //   const NotificationMessageFun = async () => {
//   //     await GetNotificationMes().then((response) => {
//   //       setNotificationMes(response?.data?.dataList);
//   //     });
//   //   };
//   //   NotificationMessageFun();
//   // }, []);

//   const NotificationMessageFun = async (data) => {
//     try {
//       const response = await GetNotificationMesDataPlayer(data); // Call your API function

//       setNotificationMes(response?.data?.dataList
//         || []); // Set the item list
//       setTotalRows(response?.data?.totalPageSize || 0); // Set the total number of rows

//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   }


//   useEffect(() => {
//     const data = {
//       "PageNumber": currentPage,
//       "PageSize": perPage,
//       "SortOrder": false,
//     };
//     NotificationMessageFun(data); // Fetch data when currentPage changes
//   }, [currentPage,perPage]);

//   const handlePerPageChange = (event) => {
//     const newPerPage = Number(event.target.value);
//     const data = {
//       "PageNumber": currentPage,
//       "PageSize": newPerPage,
//       "SortOrder": false,
//   };
//   NotificationMessageFun(data); 
   
//     setPerPage(newPerPage); // Update items per page
//     setCurrentPage(1); // Reset to first page when items per page changes
//   };

//   // Handle page change
//   const handleNextPage = () => {
//     if (currentPage < Math.ceil(totalRows)) {
//       setCurrentPage((prevPage) => prevPage + 1); // Go to next page
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
//     }
//   };

//   const indexOfLastNotification = currentPage * notificationsPerPage;
//   const indexOfFirstNotification = indexOfLastNotification - notificationsPerPage;
//   const currentNotifications = notificationMes?.slice(indexOfFirstNotification, indexOfLastNotification);


//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     setActivePage(pageNumber);
//   }
//   const totalPages = Math.ceil(notificationMes?.length / notificationsPerPage);
//   function convertUTCToLocalTime(utcDateString) {
//     const date = new Date(utcDateString);
//     return date.toString(); // Or use date.toLocaleString() for better format
//   }
//   const sidebarfun = () => {
//     setData(!data);
//   };
//   return (
//     <>
//       <TopNavbar sidebarfun={sidebarfun} />
//       <div className="dasboard-group">
//         <Sidebar data={data} />
//         <div
//           className={
//             data ? "dashboard-content full-contnet" : "dashboard-content"
//           }
//         >
//           <h1 className="heading-dash">Notification</h1>
//           <div className="group_data_table">
//             <div className="notification_box">
//               {currentNotifications?.map((ele) => {
//                 const dayjsDate = dayjs(ele?.createDate).format("MM/DD/YYYY hh:mm:ss A");
//                 return (
//                   <>
//                     <div className="notification p-2" key={ele.id}>
//                       <div className="notification-right">
//                         <div className="profile-pic2">
//                           {itemData} {itemLastData}
//                         </div>
//                         <div className="ms-3 notification-area">
//                           <h1>
//                             {ele?.createdByName}
//                           </h1>
//                           <div className="noti-msg">
//                             {ele?.message}
//                           </div>
//                           <div className="Notification-Date">
//                             {dayjsDate}
//                           </div>
//                         </div>

//                       </div>
//                     </div>
//                   </>
//                 );
//               })}

// {totalRows > 1 && (  <Row>
        
//                 <Col md={12} className='text-right'>

//                   <div className="pagination-controls">

//                     <label>Rows per page: </label>
//                     <select id="itemsPerPage" value={perPage} onChange={handlePerPageChange}>
//                       {pageOptions.map(option => (
//                         <option key={option} value={option}>{option}</option>
//                       ))}
//                     </select>

//                     <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
//                     <icons.ArrowLeft></icons.ArrowLeft>
//                     </Button>
//                     <span> {currentPage} of {totalRows} </span>
//                     <Button onClick={handleNextPage} disabled={currentPage >= Math.ceil(totalRows)}>
//                     <icons.ArrowRight></icons.ArrowRight>
//                     </Button>
//                   </div>
//                 </Col>
//               </Row>)}

//             </div>
//           </div>
//         </div>
//         <div className={data ? "Footer" : "footer-content"}>
//           <Footer />
//         </div>
//       </div>
//     </>
//   );
// };


import React, { useState, useEffect } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import { GetNotificationMesDataPlayer } from "../../redux/auth-reducer/auth-service";
import dayjs from "dayjs";
import { Button, Col, Row } from "react-bootstrap";
import * as icons from 'react-bootstrap-icons';

export const Notification = () => {
  const [data, setData] = useState(false);
  const [notificationMes, setNotificationMes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPageSize, setTotalPageSize] = useState(0);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const pageOptions = [10, 20, 30, 50];

  // Fetch notifications based on current page and per page settings
  const NotificationMessageFun = async (pageData) => {
    try {
      const response = await GetNotificationMesDataPlayer(pageData);
      
      // Set notifications from server response
      setNotificationMes(response?.data?.dataList || []);
      
      // Set total page size and record count from server
      setTotalPageSize(response?.data?.totalPageSize || 0);
      setTotalRecordCount(response?.data?.totalRecordCount || 0);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch data when page or per page changes
  useEffect(() => {
    const data = {
      "PageNumber": currentPage,
      "PageSize": perPage,
      "SortOrder": false,
    };
    NotificationMessageFun(data);
  }, [currentPage, perPage]);

  // Handle change in rows per page
  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    setPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page
  };

  // Handle page navigation
  const handleNextPage = () => {
    const totalPages = Math.ceil(totalRecordCount / perPage);
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(totalRecordCount / perPage);

  // Sidebar toggle function
  const sidebarfun = () => {
    setData(!data);
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div className={data ? "dashboard-content full-contnet" : "dashboard-content"}>
          <h1 className="heading-dash">Notification</h1>
          <div className="group_data_table">
            <div className="notification_box">
              {notificationMes?.map((ele) => {
                const dayjsDate = dayjs(ele?.createDate).format("MM/DD/YYYY hh:mm:ss A");
                return (
                  <div className="notification p-2" key={ele.id}>
                    <div className="notification-right">
                      <div className="ms-3 notification-area">
                        <h1>{ele?.createdByName}</h1>
                        <div className="noti-msg">{ele?.message}</div>
                        <div className="Notification-Date">{dayjsDate}</div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {totalRecordCount > 0 && (
                <Row>
                  <Col md={12} className='text-right'>
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select 
                        id="itemsPerPage" 
                        value={perPage} 
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map(option => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>

                      <Button 
                        onClick={handlePreviousPage} 
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft />
                      </Button>
                      <span> {" "}
                        {currentPage} of  {totalPages} {" "}
                      </span>
                      <Button 
                        onClick={handleNextPage} 
                        disabled={currentPage >= totalPages}
                      >
                        <icons.ArrowRight />
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};